import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { collection, getDocs } from 'firebase/firestore';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { db } from '../../firebase/firebase';
import TodayIcon from '@mui/icons-material/Today';

const UsuariosMes = (props) => {

    const [usuarios, setUsuarios] = useState([]);
    const [usuariosTotales, setUsuariosTotales] = useState([]);

    useEffect(() => {
        obtenerUsuarios();
    }, [])

    const obtenerUsuarios = async() =>{

        let arrayData = [];
        let arrayAux = [];

        const today = new Date();
        const now = today.getMonth()+1+'/'+today.getFullYear();

        const querySnapshot = await getDocs(collection(db, 'usuarios'))
        querySnapshot.docs.map( (doc) =>{
            if(doc.data().registro.includes(now)){
                arrayData.push(doc.data());
            }
            arrayAux.push(doc.data())
        })
        setUsuariosTotales(arrayAux);
        setUsuarios(arrayData);
    }

    
    return (
            <>
                <Card
                    sx={{ height: '100%' }}
                    {...props}
                >
                    <CardContent>
                    <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'space-between' }}
                    >
                        <Grid item>
                            <Typography
                                color="textSecondary"
                                gutterBottom
                                variant="overline"
                            >
                                REGISTRADOS ESTE MES
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="h4"
                            >
                                {usuarios.length}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Avatar
                                sx={{
                                    backgroundColor: '#3CC4F7',
                                    height: 56,
                                    width: 56
                                }}
                            >
                                <TodayIcon/>
                            </Avatar>
                        
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            pt: 2,
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {/* <ArrowDownwardIcon color="error" /> */}
                        <Typography
                            sx={{
                                mr: 1
                            }}
                            variant="body2"
                            >
                            {Math.round(usuarios.length/usuariosTotales.length*100)}%
                        </Typography>
                        <Typography
                            color="textSecondary"
                            variant="caption"
                        >
                            Del total de usuarios
                        </Typography>
                    </Box>
                    </CardContent>
                </Card>
            </>
    )
}

export default UsuariosMes